export default __webpack_public_path__ + "media/images/react_icons/location-bookings-680a93cd73d01e680f764bfd0c946a69.svg";